export default __webpack_public_path__ + "static/media/patty_overcooked.db1c2caf.svg";